import { PaymentRequestPassive } from 'lib/types/models';

import { requestHandler } from '../../api';

export async function getPaymentRequestPassive(
  dispatch: any,
  id: number,
): Promise<PaymentRequestPassive | undefined> {
  const response = await requestHandler({
    method: 'get',
    url: `internal/paymentRequestPassive/${id}`,
    dispatch,
  });
  if (response) return response.data;
}

export async function postPayoutsForPaymentRequestPassive(
  dispatch: any,
  id: number,
  data: {
    payments: any;
  },
) {
  const response = await requestHandler({
    method: 'post',
    url: `internal/paymentRequestPassive/${id}/payouts`,
    data,
    dispatch,
  });
  if (response) return response.data;
}

export const getAllPaymentRequestPassives = async (
  dispatch: any,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/paymentRequestPassive?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getPaymentRequestPassiveReversePreview = async (
  dispatch: any,
  id: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/paymentRequestPassive/${id}/reverse/preview`,
    dispatch,
  });
  if (response) return response.data;
};

export const reversePaymentRequestPassive = async (
  dispatch: any,
  id: string,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/paymentRequestPassive/${id}/reverse`,
    dispatch,
  });
  if (response) return response.data;
};

export const getPaymentRequestPassiveMissingApprovals = async (
  dispatch: any,
  data: any,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/paymentRequestPassive/${data.id}/missingApprovals`,
    dispatch,
  });
  if (response) return response.data;
};

export const makeApprovalPaymentRequestPassive = async (
  dispatch: any,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/paymentRequestPassive/${data.id}/approval`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const makeRejectPaymentRequestPassive = async (
  dispatch: any,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/paymentRequestPassive/${data.id}/reject`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const editPaymentRequestPassiveComitee = async (
  dispatch: any,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/paymentRequestPassive/${id}/comitee`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const deletePaymentRequestPassiveApproval = async (
  dispatch: any,
  id: number,
  approvalId: any,
) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/paymentRequestPassive/${id}/approval/${approvalId}`,
    dispatch,
  });
  if (response) return response.data;
};
